export default __webpack_public_path__ + "static/media/7. Hakan Dinç_3D ARTIST.ca9ce1e4.jpg";